import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import knowledgeChoiceStore from './store';
import { SVGPureIcon } from '@/ui';
import { Dropdown } from 'antd';
import iconRadioNormal from '@/assets/img/radio_normal.png';
import iconRadioActive from '@/assets/img/radio_active.png';
import client from '@/store/client';
import urlStore from '@/store/chat/urlStore';
import { useRef } from 'react';
import appLogger from '@public/log/monitor';
import userStore from '@/store/user';
import slsLogger from '@public/log/sls';

const MoreBtn = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className="text-14px h-40px leading-40px pl-34px text-black text-opacity-85 cursor-pointer hover:bg-black hover:bg-opacity-6 rounded-8px"
    >
      查看更多
    </div>
  );
};

const TitleItem = ({ title }) => {
  return (
    <div className="leading-22px text-12px text-black text-opacity-50 mt-8px pl-8px">
      {title}
    </div>
  );
};

const ListItem = ({ item, store }) => {
  return (
    <div
      key={item.folder_id}
      className="flex h-40px items-center cursor-pointer hover:bg-black hover:bg-opacity-3 rounded-8px"
      onClick={() => {
        if (store.curId == item.folder_id) {
          store.resetCurId();
        } else {
          store.switchCurId(item.folder_id);
          store.setKsId(item.ks_id);
        }
        store.setShowList(false);
      }}
    >
      <img
        className="size-16px mr-10px ml-8px"
        src={store.curId == item.folder_id ? iconRadioActive : iconRadioNormal}
      />
      <span className="text-14px text-black text-opacity-85 truncate">
        {item.name}
      </span>
    </div>
  );
};

const KnowledgeChoice = observer(props => {
  const store = knowledgeChoiceStore;
  const $refContainer = useRef(null);

  useEffect(() => {
    if(userStore.isReady && userStore.isUser){
      slsLogger.log({
        key : "preview",
        action : `init_load`,
      });

      store.loadList(0); //我创建的
      store.loadList(1); //我加入的
    }

    return () => {
      store.resetData();
    };
  }, []);

  const dropList = () => {
    return (
      <div
        className="w-260px bg-white rounded-16px pt-14px pb-12px pr-4px flex flex-col items-center mt-6px"
        style={{
          border: '1px solid rgba(0,0,0,.1)',
          boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.12)',
        }}
      >
        <div className="pl-16px pr-12px w-full">
          <div className="text-black font-bold text-14px w-full leading-20px">
            基于知识库回答
          </div>
          <div className="h-1px mt-13px w-full bg-black bg-opacity-6"></div>
        </div>
        {
          !store.list_default?.length && !store.list_create?.length && !store.list_share?.length
          ? (
            <div
              onClick={() => {
                urlStore.handleTools("knowledge");
              }}
              className={[
                'create-btn flex-shrink-0 flex items-center',
                'bg-white mt-16px',
                'w-228px h-44px text-primary border-1px border-solid rounded-12px cursor-pointer bg-white border-1px boder-black border-opacity-10 hover:bg-gray-nav-hover',
              ]}
            >
              <SVGPureIcon name="leftside_new_chat" className="size-20px mx-8px" />
              <div className="text-14px">创建我的知识库</div>
              </div>
          )
          : (
            <div className="max-h-342px overflow-y-auto w-full nw-scrollbar-thin pl-8px">
              {store.list_default?.length > 0 ? (
                <>
                  <TitleItem title={'选择：'} />
                  {store.list_default.map(item => {
                    return (
                      <ListItem key={item.folder_id} item={item} store={store} />
                    );
                  })}
                </>
              ) : null}
              {store.list_create?.length > 0 ? (
                <>
                  <TitleItem title={'我创建的专业知识库'} />
                  {store.list_create
                    .filter(item => item.is_default != 1)
                    .map(item => {
                      return (
                        <ListItem key={item.folder_id} item={item} store={store} />
                      );
                    })}
                </>
              ) : null}

              {store.list_share?.length > 0 ? (
                <>
                  <TitleItem title={'我加入的分享知识库'} />
                  {store.list_share.map(item => {
                    return (
                      <ListItem key={item.folder_id} item={item} store={store} />
                    );
                  })}
                </>
              ) : null}
            </div>
          )
        }
      </div>
    );
  };

  return (
    <Dropdown
      dropdownRender={() => dropList()}
      trigger="click"
      placement="bottomLeft"
      autoAdjustOverflow={props?.scene === 'home' ? false : true}
      open={store.showList}
      onOpenChange={
        open => {
          store.setShowList(open);
        }
      }
      getPopupContainer={
        () => $refContainer.current
      }
    >
      <div
        className={[
          'cursor-pointer select-none rounded-8px pl-[10px] pr-[12px] py-[6px] flex items-center',
          'border-1px border-solid border-[rgba(0,0,0,.1)] h-36px',
          store.curId != null
            ? '!bg-[#DCEAFE] text-[#006AFF] border-[rgba(0,0,0,0)]'
            : 'bg-gray-nav hover:bg-gray-nav-hover',
          store.showList ? 'bg-gray-nav-hover' : '',
        ]}
        ref={$refContainer}
      >
        <div className="relative size-20px rounded-6.5px overflow-hidden">
          <SVGPureIcon
            className={`relative size-20px rounded-6.5px overflow-hidden`}
            name="knowledge"
          />
        </div>
        <span className={`text-[14px] ml-6px mr-8px`}>知识库</span>
        <SVGPureIcon
          className={[
            'w-[12px] h-[8px] transform transition duration-200',
            store.showList ? 'rotate-180' : '',
          ]}
          name="down"
        />
      </div>
    </Dropdown>
  );
});

export default KnowledgeChoice;
